// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"d846f7b6","321":"f3e01045","358":"444ff30d","491":"6caad860","594":"3bd2058d","597":"ee506934","663":"a02094ea","930":"d91ef976","947":"b44901ee","989":"02405d5e"}[chunkId] + ".chunk.js";
};